
import { Component, Vue } from "vue-property-decorator";
import * as DI from "@/utility/DependencyInjector";

@Component({
  components: {},
})
export default class QuotationList extends Vue {
  //data
  isLoading = false;
  userNum = 0;
  dateTime = "";
  token!: string;

  async mounted(): Promise<void> {
    this.getTime();
    await this.login();
    await this.queryStatistic();
  }

  getTime() {
    let date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hour = date.getHours().toString().padStart(2, "0");
    const min = date.getMinutes().toString().padStart(2, "0");
    const sec = date.getSeconds().toString().padStart(2, "0");
    this.dateTime = `${year}-${month}-${day} ${hour}:${min}:${sec}`;
  }

  // 進入頁面自動登入
  async login(): Promise<void> {
    this.$store.commit("refreshPage");
    try {
      this.isLoading = true;
      await DI.get("App").auth.userLogin("0918123456", "FD@27038109");
      //登入後的狀態管理
      this.$store.commit("LoginState", true);
      this.$store.commit("setUser", DI.get("App").auth.currentUser.data);
      if (Boolean("Notification" in window) === true) {
        try {
          await import("@/utility/Firebase").then((module) => {
            let vapidKey = "";

            if (process.env.VUE_APP_BACKEND_URL === "develop") {
              vapidKey =
                "BEGS4Dt89plvDLEbAFlpwBYTd3YuU3JmL2CAP5PUBwmT6yEng98msDYjglfupscw8ILFcFB5UjoNTlQf41jiNdQ";
            } else if (process.env.VUE_APP_BACKEND_URL === "staging") {
              vapidKey =
                "BFkGVz_rWwQB75rCP5qIiM5xo2m5YpvsXBZHEwSdxmZ5nGy9YyG5oU8vQCQ2i708I7zAFsAxYadwMQTOCYIjjRk";
            } else if (process.env.VUE_APP_BACKEND_URL === "production") {
              vapidKey =
                "BFyuqAKZKI57k5O2AGVy-AwEmE_OMj7JlN9SOI3ht1VDPxVOyKsuLSqNA09_yASVPpuVtxVzElzjYTVsnqme62I";
            }
            module
              .tokenGetter(module.getMessage, { vapidKey: vapidKey })
              .then((d) => {
                this.token = d;
                this.createDevice();
              });
          });
        } catch (e) {
          console.log(e);
          console.log("create firebase token failed");
          this.token = "";
        }
      } else {
        this.token = "";
        try {
          await DI.get("App").device.create(this.token);
        } catch {
          console.log("device.create failed");
        }
      }
    } catch (errorMsg: any) {
      console.log("errorMsg.message", errorMsg.message);
      this.isLoading = false;
    }
  }
  async createDevice(): Promise<void> {
    try {
      await DI.get("App").device.create(this.token);
    } catch {
      console.log(`device create failed, please check firebase token`);
    }
  }

  // 取得用戶總數
  async queryStatistic(): Promise<void> {
    this.isLoading = true;
    try {
      const statistic = DI.get("App").statistic;
      const res = (await statistic.get()) as any as {
        detailData: {
          activeUser: number;
          appOpen: number;
          createDate: string;
          id: string;
          newRepairOrderCreated: number;
          newUserCreated: number;
          totalDealRepairOrder: number;
          totalRepairOrder: number;
          totalUser: number;
        }[];
        totalUser: number;
        totalMaster: number;
        totalRepairOrder: number;
        activeUser: number;
        totalDealRepairOrder: number;
        appOpen: number;
        smsBalance: number;
        newRepairOrder: number;
        newUser: number;
      };

      this.userNum = res.totalUser;
    } catch {
      console.log("statistic.get() fail");
    } finally {
      this.isLoading = false;
      await this.logout();
    }
  }

  // 登出
  logout(): void {
    DI.get("App").auth.logout();
    localStorage.removeItem("userState");
    this.$store.commit("LoginState", false);
  }
}
